export default function SectionTitle({ children, center = false, underline = true }) {
  return (
    <div className={center ? 'text-center' : ''}>
      <h2 className={`text-[26px] md:text-[32px] font-semibold tracking-[-0.03em] leading-tight text-white ${center ? 'mx-auto' : ''}`}>
        {children}
      </h2>
      {underline && <div className={`mt-3 h-px bg-gradient-to-r from-sky-500/40 via-cyan-400/20 to-transparent ${center ? 'mx-auto w-24' : 'w-24'}`} />}
    </div>
  );
}
